import { memo } from "react";
import PropTypes from "prop-types";
import { badgeShape } from "app/utils/propTypes";
import ProductBadge from "app/features/product/components/ProductBadge/ProductBadge";
import "./BadgeList.scss";

const BadgeList = ({ badges = [] }) => {
	const containsValidBadge = badges.some(badge => badge.label);

	return (
		containsValidBadge && (
			<div className="badge-list" data-testid="badge-list">
				{badges.map(badge => {
					const { pictoUrl, label } = badge;

					return (
						<div key={badge.label} className="badge-list__item">
							<ProductBadge pictoUrl={pictoUrl} label={label} />
						</div>
					);
				})}
			</div>
		)
	);
};

BadgeList.propTypes = {
	badges: PropTypes.arrayOf(badgeShape),
};

export default memo(BadgeList);
